'use client';

import React, { useEffect } from 'react';
import Userback, { UserbackOptions } from '@userback/widget';
import * as env from '../lib/env';
import { useUserSession } from '../store/user/hooks';
import { useLastAssistantMessage } from '../store/messages/hooks';

export function UserBack({ children }: React.PropsWithChildren) {
  const message = useLastAssistantMessage();
  const session = useUserSession();
  const { user } = session.data || {};

  const options: UserbackOptions = {
    is_live: env.isProduction,
    widget_settings: {
      form_settings: {
        general: {
          email_field: false,
        },
        bug: {
          email_field: false,
        },
        feature_request: {
          email_field: false,
        },
      },
    },
  };

  useEffect(() => {
    Userback(env.userbackToken as string, options).then((ub) => {
      ub.identify(user?.manager_id as string, {
        name: user?.manager_detail?.full_name || '',
        email: user?.manager_email || '',
      });

      ub.setData({
        'Manager ID': user?.manager_id?.toString() || '',
        Environment: env.getEnv(),
        'Execution ID': message?.executionId,
        'Property Manager ID': user?.manager_detail?.property_manager_id,
      });
    });
  }, [message, options, user]);

  return <>{children}</>;
}
